// ------ ticket.js ------
// import createTether from './lib/createTether'
import { detach } from '../plugins/detach'

export default class Ticket {
  constructor (ticketData) {
    this.mode = ticketData.mode
    this.selector = ticketData.selector
    this.environment = ticketData.environment
    this.domshot = null
    this.title = ticketData.title
    this.details = ticketData.details
    this.info = {
      number: ticketData.ticketNumber,
      title: '',
      details: '',
      replaceText: 'ReplaceText',
      tags: '[bug]',
      assignee: ''
    }
    this._status = ticketData._status
    this._id = ticketData._id
    this.id = ticketData.id
    this._user_id = ticketData._user_id
    // this._user_strategy_id = ticketData._user_strategy_id
    this._project_id = ticketData._project_id
    this._host_id = ticketData._host_id
    this._page = ticketData._page
    this._org_id = ticketData._org_id
    this._assignedTo = ticketData._assignedTo
    this._priority = ticketData._priority
    this._type = ticketData._type
    this._files = ticketData.files || []
    this._epic = ticketData._epic
    this._sprint = ticketData._sprint
    this._parent = ticketData._parent
    this.annotations = []
    this.integration = null
    // Create ticket DOM element
    this.$elHidden = null
    this.createdAt = ticketData.createdAt
    this.createdAtFormattedWordsToNow = ticketData.createdAtFormattedWordsToNow
    // this.hidden = false
    // this.orphan = false
    this.highlights = []
    // this.adjustForTransforms = false
    // this.ajdustForTransformsEl = {}
    // Store just for 'create'
    this.create = {
      documentOffset: ticketData.documentOffset,
      target: ticketData.target
    }
    this.offset = {}

    // Lets store offset here to, in the legacy location
    this.offset.fromDocument = ticketData.documentOffset

    // New tether object.  will eventually replace create and offset above
    this.position = ticketData.position
    return this
  }

  addAnnotation (newAnnotation) {
    this.annotations.push(newAnnotation)
  }

  addHighlight (highlight) {
    this.highlights.push(highlight)
  }

  /**
   * Restore ticket from saved data.  overrwites contructed values
   */
  restore (ticketData) {
    console.log('RESORET__', ticketData.selector)
    this.info = ticketData.info
    this.environment = ticketData.environment
    this.offset = ticketData.offset
    this.tether = ticketData.tether
    this.title = ticketData.title
    this.details = ticketData.details
    this.domshot = ticketData.domshot
    this.integration = ticketData.integration ? ticketData.integration : null
    this.integrationId = ticketData.integrationId
      ? ticketData.integrationId
      : null
    this.integrationUrl = ticketData.integrationUrl
      ? ticketData.integrationUrl
      : null
    this.annotations = ticketData.annotations || []
    this._user_id = ticketData._user_id
    this._user_strategy_id = ticketData._user_strategy_id
    this._assignedTo = ticketData._assignedTo
    this._status = ticketData._status
    this._priority = ticketData._priority
    this._type = ticketData._type
    this._files = ticketData._files || []
    this.highlights = ticketData.highlights || []
    this._project_id = ticketData._project_id
    this._host_id = ticketData._host_id
    this._page = ticketData._page || []
    this._org_id = ticketData._org_id
    this.mode = ticketData.mode
    this._id = ticketData._id
    this.id = ticketData.id
    this._epic = ticketData._epic
    this._sprint = ticketData._sprint
    this._parent = ticketData._parent
    this.selector = ticketData.selector ? JSON.parse(ticketData.selector) : []
    this._modifiedBy = ticketData._modifiedBy || null
    this._modifiedByStrategy = ticketData._modifiedByStrategy || null
    this.modifiedAt = ticketData.modifiedAt || null
    this.modifiedAtFormattedWordsToNow =
      ticketData.modifiedAtFormattedWordsToNow
    // // update tootip
    // if (this.$el) {
    //   this.$el.attr('aria-label', this.info.title)
    // }
    return this
  }

  /**
   * Return object with only data necessary to re-create af
   */
  exportData () {
    console.log('EXPOR DATA:')
    // console.log(this._user)
    // console.log(((typeof this._user === 'string') || this._user === undefined ) ? this._user : this._user._id)
    console.log('export selector', detach(this.offset))

    return {
      mode: this.mode,
      selector: JSON.stringify(detach(this.selector)),
      offset: JSON.stringify(this.offset),
      position: JSON.stringify(this.position),
      environment: JSON.stringify(this.environment),
      domshot: this.domshot,
      info: this.info,
      title: this.title,
      details: this.details,
      integration: this.integration,
      integrationId: this.integrationId,
      integrationUrl: this.integrationUrl,
      _id: this._id,
      id: this.id,
      _user:
        typeof this._user === 'string' || this._user === undefined
          ? this._user
          : this._user._id,
      _user_id: this._user_id,
      _user_strategy_id: this._user_strategy_id,
      _project_id: this._project_id,
      _host_id: this._host_id,
      // _page: this._page,
      _org_id: this._org_id,
      _assignedTo: this._assignedTo,
      _status: this._status,
      // _status_is_updated: this._status_is_updated || false,
      _priority: this._priority,
      _type: this._type,
      _files: this._files,
      _epic: this._epic,
      _sprint: this._sprint,
      _parent: this._parent
    }
  }
}
